import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ breakpoints }: Theme) =>
  createStyles({
    flavorsCostContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '50%',
      [breakpoints.down('md')]: {
        width: '100%',
      },
    },
    searchForm: {
      display: 'flex',
      width: '100%',
      [breakpoints.down('sm')]: {
        width: '80%',
      },
      [breakpoints.down('xs')]: {
        width: '90%',
      },
      alignItems: 'center',
      padding: '5px 0px',
      margin: '16px 0',
    },
    searchButton: {
      alignItems: 'center',
      justifyContent: 'flex-end',
      display: 'flex',
      [breakpoints.down('md')]: {
        width: '20%',
      },
      [breakpoints.down('xs')]: {
        width: '100%',
        justifyContent: 'center',
      },
    },
    searchButtonText: {
      fontSize: 12,
      whiteSpace: 'nowrap',
      margin: '0px 5px',
    },
    header: { alignItems: 'center', justifyContent: 'space-between' },
    searchFormContainer: {
      width: '60%',
      [breakpoints.down('md')]: {
        width: '80%',
      },
      [breakpoints.down('xs')]: {
        justifyContent: 'center',
        width: '100%',
      },
    },
    superAdminIcon: {
      fontSize: 15,
      width: 15,
      height: 15,
      cursor: 'pointer',
      opacity: 0.5,
      backgroundColor: palette.lightNavSuperAdminActions,
      color: palette.navSuperAdmin,
      borderRadius: 5,
    },
    flavorsCostTable: {
      height: '100%',
    },
  });

export const overrideFilter = {
  text: {
    fontWeight: 500,
    fontSize: 14,
  },
  listItem: { '& .MuiTypography-body1': { fontSize: 14 } },
};
